export enum UserEventType {
  'signup' = 'signup',
  'activated' = 'activated',
  'note' = 'note',
  'editProfile' = 'editProfile',
  'deactivated' = 'deactivated',
  'photoUpload' = 'photoUpload',
  'photoDeleted' = 'photoDeleted',
  'foodCreated' = 'foodCreated',
  'foodImported' = 'foodImported',
}

export enum UserActivityType {
  'reg' = 'reg',
  'coaching' = 'coaching',
  'referral' = 'referral',
  'success' = 'success',
  'other' = 'other',
}

export interface UserEvent {
  id: number;
  createdAt: Date;
  eventType: UserEventType;
  activityType?: UserActivityType;
  byUserId: number;
  forUserId: number;
  note?: string;
}
